<template>


   <img class="logo" src="../assets/LSV-Logo.svg"  alt="LSV Logo" />
  <h1>LSV Michelsberg e.V.</h1>
  <h1>Digitales Flugbuch</h1>
  <form @submit.prevent="login">
    <h2 class="formlabel">Login</h2>
    <div v-if="error" class="error">{{error}}</div>
    <label>Email</label>
    <input v-model="email" type="email" />
    <label>Passwort</label>
    <input v-model="password" :type="pwdVisible ? 'text' : 'password'" />
    <div class="input-line">
      <input v-model="pwdVisible" type="checkbox">
      <label >Passwort anzeigen</label>
    </div>   
    <input class="login" type="submit" value="Einloggen" />
  </form>
  <div>
  <a href="https://www.lsv-michelsberg.de/impressum">Impressum</a>
  </div>
  <div>
  <a href="https://www.lsv-michelsberg.de/datenschutz">Datenschutzerklärung</a>
  </div>
  


</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "Login",
  data(){
    return {
      pwdVisible:false
    }

  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const email = ref();
    const password = ref();
    const error = ref(null);
    const vw = computed(()=> window.innerWidth)
    const scale = computed(()=> window.devicePixelRatio)
    const login = async () => {
      console.log("Login Vue: login");
      try {
        const credentials ={
          email: email.value,
          password: password.value,
        }
        await store.dispatch("login", credentials);
        router.push({ name: "Home" });
      } catch (err) {
        console.log(err.message);
        if (err.message==="Request failed with status code 403") {
          error.value = "Email oder Passwort falsch! Bitte korrigiere deine Eingaben."
        } else if (err.message==="Network Error") {
          error.value = "Keine Verbindung zum Server. Bitte kontrolliere, ob du deine mobilen Daten eingeschaltet hast."
        }
      }
    };
    return { email, password, error, login, vw, scale };
  },
};
</script>

<style scoped>
form {
  width: 80%;
  margin: 0px auto;
  background: white;
  text-align: left;
  padding: 10px;
  border-radius: 15px;
  box-sizing: border-box;
}

.formlabel {
  margin: 0;
}
label {
  display: inline-block;
  margin: 20px 0 10px;
  font-size: 18px;
}

input {
  font-size: 16px;
  -webkit-text-size-adjust: none; /* Disable text size adjustment for WebKit browsers */
  -moz-text-size-adjust: none; /* Disable text size adjustment for Mozilla browsers */
  -ms-text-size-adjust: none; /* Disable text size adjustment for Microsoft browsers */
  text-size-adjust: none; /* Disable text size adjustment for other browsers */

  display: block;
  padding: 10px 15px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  background-color: #f2f2f2;
}

input[type="checkbox"]{
    display:inline-block;
    width: 20px;
    margin: 0 10px 0 0;
    position: relativ;
    top: 2px;
}

.login {
  background-color: crimson;
  color:white;
  margin: 30px 0;
  font-size: 18px;
}

.logo {
  width: 100px;
  height: 100px;
  margin: 10px auto;
 
}

.error {
  background-color:#f594a7;
  padding: 15px;
  border-radius: 20px;
  font-size: 18px;
}

.login-page {
  overflow-y: scroll;
}
</style>